import React from "react";
import { useSelector, useDispatch } from "types/store";
import { Button } from "aible";
import { toast } from "react-toastify";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import { getDataset } from "@/containers/Home/reducer";
import { fromDataSource } from "@/utils/relation";
import { exportToFile } from "@/utils/fileExportImport";
const BlueprintExport = ({ label, blueprintName, blueprint, children, style, mode = "download" } = {}) => {
    const dispatch = useDispatch();
    const blueprintId = useSelector((state) => blueprint?.id ?? chatGPTReducer.getBlueprintId(state));
    blueprint = useSelector((state) => blueprint ?? blueprintReducer.getBlueprint(state, blueprintId));
    const blueprintSettings = useSelector((state) => blueprint?.wizard?.isChatApp ? {} : chatGPTReducer.getBlueprintSettings(state, blueprintId, true));
    const getBlueprint = (bpId) => dispatch((dispatch, getState) => {
        const bp = blueprintReducer.getBlueprint(getState(), bpId) ?? {};
        const bpSettings = chatGPTReducer.getBlueprintSettings(getState(), bpId, true);
        return {
            ...bp,
            wizard: {
                ...(bp.wizard ?? {}),
                chatGPT: {
                    ...bpSettings,
                    lineage: []
                }
            }
        };
    });
    const blueprintDatasetId = blueprint?.wizard?.steps?.["0"]?.datasetId;
    const blueprintDataset = useSelector((state) => getDataset(state, blueprintDatasetId));
    if (blueprintDataset !== undefined) {
        const datasetSettings = {
            options: blueprintDataset.options,
            target: blueprintDataset.target,
            target_value: blueprintDataset.target_value,
            transformations: blueprintDataset.transformations
        };
        if (datasetSettings.transformations.plan?.relation === undefined) {
            datasetSettings.transformations.plan = {
                relation: fromDataSource(blueprintDataset.source).build()
            };
        }
        blueprint.wizard.steps["0"].datasetSettings = datasetSettings;
    }
    const retBlueprint = {
        ...blueprint,
        wizard: {
            ...blueprint?.wizard,
            chatGPT: {
                // ...blueprint?.wizard?.chatGPT,
                ...blueprintSettings,
                lineage: []
            }
        }
    };
    const handleExportBlueprint = () => {
        const exportBlueprint = {
            ...retBlueprint,
            name: blueprintName ?? retBlueprint.name
        };
        if (exportBlueprint?.wizard?.isChatApp) {
            delete exportBlueprint.wizard.chatGpt;
            //Export the blueprint mentioned in the steps also
            const stepsBlueprints = {};
            const stepsBpIds = Object.keys(blueprint?.wizard?.steps ?? {})
                .map((sKey) => {
                return blueprint.wizard.steps[sKey]?.chatBlueprintId;
            })
                .filter((bpId) => !isNaN(Number(bpId)));
            if (stepsBpIds.length) {
                stepsBpIds.forEach((bpId) => {
                    stepsBlueprints[bpId] = getBlueprint(bpId);
                });
                exportBlueprint.stepsBlueprints = stepsBlueprints;
            }
        }
        if (mode === "download") {
            exportToFile(exportBlueprint);
        }
        else {
            toast(`Agent Template: ${retBlueprint.name} copied to clipboard.`, {
                type: toast.TYPE.SUCCESS,
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3500
            });
            navigator.clipboard.writeText(JSON.stringify(exportBlueprint));
        }
    };
    return (React.createElement(React.Fragment, null, children ? (React.createElement("div", { style: style, onClick: handleExportBlueprint }, children)) : (React.createElement(Button, { onClick: handleExportBlueprint, type: "secondary", style: style }, label ?? "Export"))));
};
export default BlueprintExport;
